import { removeProbmelDto } from './../Models/remove-problem-dto';
import { Component, OnInit } from '@angular/core';

// Observable class extensions

// Observable operators



import { MessageBox } from '../shared/message-box/message-box';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-sponsor',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss'],
    providers: [MessageBox]
})
export class AlertDialogComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<AlertDialogComponent>) { }

    remove: removeProbmelDto = new removeProbmelDto();
    IsYesNo: boolean = false;
    IsOk: boolean = false;
    AgreeNotAgree: boolean = false;
    LoginOrNot: boolean = false;
    HasString: boolean = false;
    content: string = null;
    header: string = null;
    headerBackgroundColor: string = "orangeBack";
    description: string;
    retunValue: any = {
        keyValue: "yes",
        descrption: null,
    };
    ngOnInit() {
        this.remove.description = this.description;
        this.retunValue.description=this.description;
    }
    close(keyValue: string, descrption: string) {
        this.retunValue.keyValue = keyValue;
        this.retunValue.descrption = descrption;
        this.dialogRef.close(this.retunValue);
    }
}
